<div [id]="'partner-' + partner?.id" [ngClass]="{ 'no-border-top': noBorderTop, 'no-border-bottom': noBorderBottom }"
  class="clinic-card-wrapper d-flex flex-column flex-sm-row gap-3 p-sm-0 p-lg-3 mt-2" style="cursor: pointer;">

  <ng-container *ngIf="screenSize.isMobile; else desktopContent">
    <ng-template [ngTemplateOutlet]="mobileContent"></ng-template>
  </ng-container>

  <ng-template #desktopContent>
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </ng-template>

</div>

<ng-template #mobileContent>
  <div class="clinic-inner-content d-flex justify-content-between align-items-stretch w-100" style="height: 130px;"
    (click)="navigateToDetail()">

    <div class="img-container ratio ratio-1x1 flex-shrink-0 position-relative" style="max-width: 200px;">
      <app-shimmer-loader *ngIf="!coverImageMobileLoaded" height="100%" width="100%"
        class="position-absolute top-0 start-0">
      </app-shimmer-loader>

      <img class="w-100 h-100 object-fit-cover rounded-2 clickable-image" (load)="onMobileImageLoad()"
        (error)="onImageError($event, true)" #coverImgMobile [src]="partner?.coverUrl ?? 'assets/dentalclinic.webp'"
        [class.d-none]="!coverImageMobileLoaded" style="cursor: pointer;" />
    </div>

    <div class="d-flex flex-column justify-content-between title-container">
      <!-- TITOLO -->
      <div class="w-100">
        <h5 class="d-flex flex-row w-100 justify-content-between align-items-top mb-1 fixed-height">
          <div class="d-flex flex-column">
            <span class="fw-semibold hover-darken small clickable-title" style="cursor: pointer;">
              {{ partner?.name }}
            </span>
            <div class="subtitle-container small text-muted d-flex flex-column align-items-start pb-1 text-break">
              <span>
                {{ partner?.region | placeName }} - {{ partner?.country }}
              </span>
              <div class="mt-1">
                <ng-template [ngTemplateOutlet]="languages"></ng-template>
              </div>
            </div>
          </div>
          <div *ngIf="hasReviews" class="d-flex flex-column align-items-end justify-content-top gap-1"
            (click)="openReviewsOffcanvas($event)" style="cursor: pointer;">
            <div>
              <app-rating-badge [averageRate]="partner?.averageRate"></app-rating-badge>
            </div>
            <span class="text-muted review hover-text">
              {{ reviewsLabel | translate }}
            </span>
          </div>
        </h5>
      </div>

      <div class="d-flex flex-column justify-content-start w-100">
        <div class="review-block text-muted">
          <app-review [review]="partner?.topReview" [italic]="true" [fakeLink]="true" [small]="true"
            style="cursor: pointer;" [quotation]="true"></app-review>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #content>
  <div class="d-flex flex-column flex-sm-row gap-3 w-100" (click)="navigateToDetail()">

    <div class="ratio ratio-1x1 w-100 w-sm-auto flex-shrink-0 position-relative" style="max-width: 200px;">
      <app-shimmer-loader *ngIf="!coverImageLoaded" height="100%" width="100%" class="position-absolute top-0 start-0">
      </app-shimmer-loader>

      <img (load)="onImageLoad()" (error)="onImageError($event, false)" #coverImg
        [src]="partner?.coverUrl ?? 'assets/dentalclinic.webp'" [class.d-none]="!coverImageLoaded"
        class="object-fit-cover w-100 h-100 rounded-2 clickable-image" alt="Clinic cover" style="cursor: pointer;" />
    </div>

    <!-- CONTENUTO -->
    <div class="d-flex flex-column justify-content-between gap-4 w-100">

      <!-- TITOLO -->
      <div class="w-100">
        <h5 class="d-flex w-100 justify-content-between align-items-start mb-1">
          <div class="d-flex flex-column">
            <span class="text-break fw-semibold hover-darken small clickable-title" style="cursor: pointer;">
              {{ partner?.name }}
            </span>
            <div class="subtitle-container small text-muted d-flex flex-column align-items-start pb-1 text-break">
              <span>
                {{ partner?.region | placeName }} - {{ partner?.country }}
              </span>
            </div>
          </div>

          <div>
            <ng-container *ngIf="isLong; else shortLayout">
              <div *ngIf="hasReviews" class="d-flex flex-column align-items-end gap-1"
                (click)="openReviewsOffcanvas($event)" style="cursor: pointer;">
                <div>
                  <app-rating-badge [averageRate]="partner?.averageRate"></app-rating-badge>
                </div>
                <span class="text-muted review hover-text small review-clickable">
                  {{ reviewsLabel | translate }}
                </span>
              </div>

            </ng-container>

            <ng-template #shortLayout>
              <div class="d-flex flex-row align-items-center gap-2" *ngIf="hasReviews"
                (click)="openReviewsOffcanvas($event)" style="cursor: pointer;">
                <span class="text-muted review hover-text small review-clickable"
                  style="cursor: pointer; z-index: 10; position: relative;">
                  {{ reviewsLabel | translate }}
                </span>
                <div>
                  <app-rating-badge [averageRate]="partner?.averageRate"></app-rating-badge>
                </div>
              </div>

            </ng-template>
          </div>

        </h5>
        <ng-template [ngTemplateOutlet]="languages"></ng-template>
      </div>

      <div class="review-block text-muted">
        <app-review [small]="true" [fakeLink]="true" [italic]="true" [review]="partner?.topReview"
          style="cursor: pointer;" [quotation]="true"></app-review>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #languages>
  <div class="d-flex align-items-center gap-1 flex-wrap flags">
    <span class="material-symbols-rounded d-flex align-items-center spoken-languages languages-icon">language</span>
    <img *ngFor="let flag of flagsSrcs" [src]="flag.src" [alt]="flag.name | translate" [title]="flag.name | translate"
      [attr.aria-label]="flag.name | translate" />
  </div>
</ng-template>